module.exports = __webpack_public_path__ + "static/Reword-b3c8f2569c1affb4ec4a41e6962dbea3.png";